// extracted by mini-css-extract-plugin
export var container = "e1b87";
export var noMargin = "de2ff";